import DragCard from './DragCard';

export default DragCard;
